// extracted by mini-css-extract-plugin
export default {"noDataRow":"tableBody_noDataRow__tVsHQ"};